import { render, staticRenderFns } from "./TaskRelatedRecords.vue?vue&type=template&id=65aede95"
import script from "./TaskRelatedRecords.vue?vue&type=script&lang=js"
export * from "./TaskRelatedRecords.vue?vue&type=script&lang=js"
import style0 from "./TaskRelatedRecords.vue?vue&type=style&index=0&id=65aede95&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports